<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="780px"
    @keydown.esc="closeMeetingInvitaionDialog"
  >
    <v-card id="meetingInvitation">
      <div class="dialog-header">
        <h3 class="popup-title">참석자</h3>
        <div class="header-btn" style="margin-right: 30px">
          <button class="btnPrimary" @click="openOrganizationDialog()">
            조직도
          </button>
        </div>
      </div>

      <div class="popup_tel_wrap">
        <div class="member_warp" style="min-height: 210px">
          <div class="list_info">
            <div
              class="attendees-list-header"
              v-bind:style="{ display: isActive }"
            >
              <div
                style="
                  color: #666;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 150%; /* 21px */
                  letter-spacing: -0.56px;
                "
              >
                참석자 목록
              </div>
              <button class="delete_all" @click="selectAllDelete()">
                전체삭제
              </button>
            </div>
            <div class="con">
              <div class="room">
                <ul
                  class="user_list"
                  style="
                    overflow: auto;
                    height: 170px;
                    max-height: 200px;
                    padding-right: 20px;
                  "
                >
                  <div
                    v-if="attendees.length === 0"
                    style="
                      padding-top: 10%;
                      font-weight: 300;
                      text-align: center;
                    "
                  >
                    회의에 참여할 사용자를 초대해 주세요
                  </div>
                  <li
                    v-for="(attendee, index) in attendees"
                    v-bind:item="attendee"
                    v-bind:index="index"
                    v-bind:key="attendee.email"
                  >
                    <div v-if="attendee.callNm" class="detail_member_04">
                      {{ attendee.name }} ({{ attendee.callNm }})
                    </div>
                    <img
                      style="cursor: pointer"
                      src="../../../src/images/button/btnClose.png"
                      @click="selectDelete(attendee)"
                    />
                  </li>
                </ul>
              </div>
            </div>
            <!-- //con -->
          </div>
          <!-- //list_info -->
        </div>
      </div>

      <!-- //.popup_tel_wrap -->
      <div class="btnArea">
        <div style="position: relative"></div>
        <div style="display: flex; justify-content: center">
          <button class="noIconButton" @click="closeMeetingInvitation()">
            닫기
          </button>
          <button
            class="btnPrimary"
            @click="closeMeetingInvitaionDialog(attendees, exMeeting)"
          >
            완료
          </button>
        </div>
      </div>
    </v-card>
    <!-- 즐겨찾기 추가 -->
    <bookmark-create-dialog
      :dialog="bookmarkCreateDialog.dialog"
      :attendees="attendees"
      :closeDialog="closeBookmarkCreateDialog"
    />

    <!-- 엑셀 다운로드 -->
    <excel-create-dialog
      :dialog="excelCreateDialog.dialog"
      :closeDialog="closeExcelUploadDialog"
    />

    <!-- 즐겨찾기 목록 보기 -->
    <bookmark-dialog
      :dialog="bookmarkDialog.dialog"
      :closeDialog="closeBookmarkDialog"
    />

    <!-- 최근 참석자 -->

    <recently-bookmark-dialog
      :dialog="recentlyBookmarkDialog.dialog"
      :closeDialog="closeRecentlyBookmarkDialog"
    />
    <!-- 조직도 -->
    <organization-chart-dialog
      @createSelectedList="createSelectedList"
      :dialog="organizationChartDialog.dialog"
      :closeDialog="closeOrganizationDialog"
    />

    <!-- 개인주소록 -->
    <personal-address-dialog
      :dialog="personalAddressDialog.dialog"
      :closeDialog="closePersonalAddressDialog"
    />

    <!-- 참석자 등록 -->
    <add-attendee-dialog
      :dialog="addAttendeeDialog.dialog"
      :closeDialog="closeAddAttendeeDialog"
    />
  </v-dialog>
</template>
<script>
import Util from '@/util';

import MeetingCreate from '@/components/meeting/MeetingCreate';
import BookmarkDialog from '@/components/popup/BookmarkDialog';
import RecentlyBookmarkDialog from '@/components/popup/RecentlyBookmarkDialog';
import BookmarkCreateDialog from '@/components/popup/BookmarkCreateDialog';
import organizationChartDialog from '@/components/popup/organizationChartDialog';
import PersonalAddressDialog from '@/components/popup/PersonalAddressDialog';
import AddAttendeeDialog from '@/components/popup/AddAttendeeDialog';
import debounce from 'lodash.debounce';
import ExcelCreateDialog from '@/components/popup/ExcelCreateDialog';

export default {
  components: {
    MeetingCreate,
    BookmarkDialog,
    RecentlyBookmarkDialog,
    BookmarkCreateDialog,
    ExcelCreateDialog,
    organizationChartDialog,
    PersonalAddressDialog,
    AddAttendeeDialog,
  },
  props: [
    'dialog',
    'attendeesInfo',
    'exMeeting',
    'closeMeetingInvitaionDialog',
    'noticeInfo',
  ],
  data() {
    return {
      exUserDialbled: false,
      loading: false,
      invitationEmail: null,
      isHelpActive: 'none',
      isActive: 'none',
      isLayoutActive: 'none',
      organizationChartDialog: {
        dialog: false,
      },
      personalAddressDialog: {
        dialog: false,
      },
      excelCreateDialog: {
        dialog: false,
      },
      recentlyBookmarkDialog: {
        dialog: false,
      },
      bookmarkDialog: {
        dialog: false,
      },
      addAttendeeDialog: {
        dialog: false,
      },
      bookmarkCreateDialog: {
        dialog: false,
      },
      layoutDialog: {
        dialog: false,
      },
      searchName: null,
      isLoading: false,
      search: null,
      friends: [],
      isUpdating: false,
      organization: [],
      attendees: [],
      editedAttendees: [],
      selected: null,
      searchPeople: null,
      checked: [],
      allSelected: false,
      selectTitle: '전체선택',
      selectedList: [],
      /* 임직원 검색 */
      people: [],
      checkedMember: [],
      isOs: '',
    };
  },
  computed: {
    attendeesString() {
      let attendees_str = '';

      if (this.attendees.length === 1) {
        if (this.attendees[0].name) {
          attendees_str = `${this.attendees[0].name}`;
        } else {
          attendees_str = `${this.attendees[0].email}`;
        }
      } else if (this.attendees.length > 1) {
        if (this.attendees[0].name) {
          attendees_str = `${this.attendees[0].name} 외 ${
            this.attendees.length - 1
          }명`;
        } else {
          attendees_str = `${this.attendees[0].email} 외 ${
            this.attendees.length - 1
          }명`;
        }
      }
      return attendees_str;
    },
  },
  watch: {
    dialog: async function (newVal) {
      if (!this.exMeeting) {
        this.exUserDialbled = false;
      }
      let os = Util.getOS();
      if (os.indexOf('window') === -1) {
        this.isOs = 'none';
      }
      if (newVal === true) {
        if (this.attendeesInfo && this.attendeesInfo.length >= 1) {
          this.attendees = this.attendeesInfo;
          this.isActive = '';
        } else {
          this.attendees = [];
          this.isActive = 'none';
        }
      }

      // if (exMeetingUser.length) {

      // }
    },
    search(val) {
      this.searchName = val;
    },
    searchPeople: function (newVal) {
      if (this.attendees.length === 0) {
        this.attendees.push(newVal);
      } else {
        // let attendeesEmail = this.attendees.map(at => at.email);
        // this.attendees = this.attendees.concat(!attendeesEmail.includes(newVal.email) ? newVal : null);
        let isDupUser = this.attendees.find((at) => at.email === newVal.email);
        if (!isDupUser) {
          this.attendees.push(newVal);
        }
      }

      this.isActive = '';
    },
  },
  methods: {
    addEmail() {
      let validEmail = this.validEmail(this.invitationEmail);
      let validPhone = Util.validationNumber(this.invitationEmail);
      console.log(`validPhone : `, validPhone);

      if (!validEmail && !validPhone) {
        alert('이메일 또는 휴대폰 형식을 확인하세요');
        return;
      }

      let attendee = {};
      if (validPhone) {
        attendee = {
          name: this.invitationEmail,
          phone: this.invitationEmail,
        };
      }

      if (validEmail) {
        attendee = {
          email: this.invitationEmail,
        };
      }

      let importAttendees = [];
      importAttendees.push(attendee);

      let attendeesEmail = this.attendees.map((at) => at.email || at.phone);
      this.attendees = this.attendees.concat(
        importAttendees.filter((a) => !attendeesEmail.includes(a.email)),
      );
      this.isActive = '';
      this.invitationEmail = null;
      this.exMeeting = true;
      this.exUserDialbled = true;
    },
    initInvitaion() {
      // this.attendees = [];
      this.selectedList = [];
    },
    openOrganizationDialog() {
      /* 조직도 */
      this.organizationChartDialog.dialog = true;
    },
    closeOrganizationDialog() {
      this.organizationChartDialog.dialog = false;
    },
    openAddAttendeeDialog() {
      this.addAttendeeDialog.dialog = true;
    },
    closeAddAttendeeDialog() {
      this.addAttendeeDialog.dialog = false;
    },
    openPersonalAddressDialog() {
      /* 개인주소록 */
      this.personalAddressDialog.dialog = true;
    },
    closePersonalAddressDialog(bookmark) {
      if (bookmark && bookmark.attendees && bookmark.attendees.length >= 1) {
        let attendeesEmail = this.attendees.map((at) => at.email);
        this.attendees = this.attendees.concat(
          bookmark.attendees.filter((a) => !attendeesEmail.includes(a.email)),
        );
        this.isActive = '';

        let validEmailList = bookmark.attendees.filter((el) =>
          this.validEmail(el.email),
        );
        let validPhoneList = bookmark.attendees.filter((el) =>
          Util.validationNumber(el.email),
        );

        validEmailList = validEmailList.filter(
          (el) => el.email.indexOf('@krx.co.kr') === -1,
        );
        let count = validEmailList.length + validPhoneList.length;
        if (count > 0) {
          this.exMeeting = true;
          this.exUserDialbled = true;
        }
      }

      this.personalAddressDialog.dialog = false;
    },
    openBookmarkCreateDialog() {
      if (this.attendees.length === 0) {
        alert('참석자 추가 후 이용해주세요');
      } else {
        console.log(this.attendees);
        this.bookmarkCreateDialog.dialog = true;
      }
    },
    closeBookmarkCreateDialog() {
      this.bookmarkCreateDialog.dialog = false;
    },
    openExcelUploadDialog() {
      console.log(this.selected);
      this.excelCreateDialog.dialog = true;
    },
    closeExcelUploadDialog(importAttendees) {
      if (importAttendees && importAttendees.length >= 1) {
        let attendeesEmail = this.attendees.map((at) => at.email);
        importAttendees.forEach((el) => {
          el.phone = el.phone + '';
          el.phone = el.phone.replace(/-/gi, '');
          // if (el.email || el.phone) {
          //   if (el.phone.indexOf("-") !== -1) {
          //     el.phone.replace("-", "").replace("-", "");
          //   }
          // }
        });

        console.log(importAttendees);
        this.attendees = this.attendees.concat(
          importAttendees.filter((a) => !attendeesEmail.includes(a.email)),
        );

        this.exMeeting = true;
        this.exUserDialbled = true;
        this.isActive = '';
      }

      this.excelCreateDialog.dialog = false;
    },
    openLayoutDialog() {
      this.layoutDialog.dialog = true;
    },
    closeLayoutDialog() {
      this.layoutDialog.dialog = false;
    },
    closeMeetingInvitation() {
      if (this.attendees.length === 0) {
        this.isActive = 'none';
        this.exMeeting = false;
      } else {
        this.isActive = '';
        this.exMeeting = false;
        this.exUserDialbled = false;
      }
      if (this.attendeesInfo) {
        let validEmailList = this.attendeesInfo.filter((el) =>
          this.validEmail(el.email),
        );

        validEmailList = validEmailList.filter(
          (el) => el.email.indexOf('@krx.co.kr') === -1,
        );
        let validPhoneList = this.attendeesInfo.filter((el) =>
          Util.validationNumber(el.email),
        );

        if (this.attendeesInfo.length > 0) {
          let count = validEmailList.length + validPhoneList.length;
          if (count > 0) {
            this.exMeeting = true;
            this.exUserDialbled = true;
          }

          if (this.attendees.length === 0) {
            this.exMeeting = false;
            this.exUserDialbled = false;
          }
          this.closeMeetingInvitaionDialog(this.attendees, this.exMeeting);
        } else {
          this.exMeeting = false;
          this.exUserDialbled = false;
          this.closeMeetingInvitaionDialog();
        }
      } else {
        this.closeMeetingInvitaionDialog();
      }
    },
    remove(item) {
      const index = this.friends.indexOf(item.name);
      if (index >= 0) this.friends.splice(index, 1);
    },
    searchUser: debounce(async function (text) {
      this.people = [];
      await this.$http
        .get('/api/v1/organizations/filtered', {
          params: {
            search: text,
          },
        })
        .then((response) => {
          console.log(response);
          this.organization = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    }, 200),
    // searchUser: debounce(async function () {
    //   let params = {
    //     search: this.searchName,
    //     limit: 100,
    //     includeUsers: true,
    //     includePersonal: true
    //   };

    //   await this.$http.get('/api/v1/organizations/filtered', { params: params }).then(response => {

    //     this.organization = response.data.splice(0, 100);
    //     console.log(this.organization);
    //   }).catch(error => {
    //     console.log(error);
    //   });
    // }, 200),

    deleteAttendee(index) {
      this.attendees.splice(index, 1);
    },
    selectAll() {
      this.checked = [];

      if (this.allSelected) {
        this.attendees.forEach((attendee) => {
          // attendee.checked = false;
        });
        this.selectTitle = '전체선택';
        this.allSelected = false;
      } else {
        if (this.attendees.length === 0) {
          /* 참여자가 0이면 전체선택 안되도록 */
        } else {
          this.attendees.forEach((attendee) => {
            this.checked.push(attendee.email);
          });
          this.selectTitle = '선택해제';
          this.allSelected = true;
        }
      }
    },
    selectDelete(attendee) {
      let attendees = this.attendees;

      for (let i = 0; i < attendees.length; i++) {
        if (attendee.email) {
          if (attendee.email === attendees[i].email) {
            attendees.splice(i, 1);
          }
        } else if (attendee.phone) {
          if (attendee.phone === attendees[i].phone) {
            attendees.splice(i, 1);
          }
        }
      }

      let validEmailList = attendees.filter(
        (el) =>
          el.email.indexOf('@krx.co.kr') === -1 && this.validEmail(el.email),
      );
      let validPhoneList = attendees.filter((el) =>
        Util.validationNumber(el.email),
      );

      validEmailList = validEmailList.filter(
        (el) => el.email.indexOf('@krx.co.kr') === -1,
      );
      let count = validEmailList.length + validPhoneList.length;

      if (attendees.length === 0) {
        this.attendees = [];
        this.isActive = 'none';
        this.exMeeting = false;
        this.exUserDialbled = false;
      } else {
        if (count === 0) {
          this.exMeeting = false;
          this.exUserDialbled = false;
        }
      }
    },
    selectAllDelete() {
      this.attendees = [];
      this.isActive = 'none';
      this.exMeeting = false;
      this.exUserDialbled = false;
    },
    select() {
      this.allSelected = false;
      this.selectTitle = '전체선택';
    },
    selectDel() {
      let list = [];
      for (let index = 0; index < this.attendees.length; index++) {
        let select = false;
        for (
          let check_index = 0;
          check_index < this.checked.length;
          check_index++
        ) {
          if (this.checked[check_index] === this.attendees[index].email) {
            select = true;
            break;
          }
        }
        if (!select) {
          list.push(this.attendees[index]);
        }
      }
      this.attendees = list;
    },
    openRecentlyBookmarkDialog() {
      this.recentlyBookmarkDialog.dialog = true;
    },
    openBookmarkDialog() {
      this.bookmarkDialog.dialog = true;
    },
    closeRecentlyBookmarkDialog(bookmark) {
      if (bookmark && bookmark.attendees && bookmark.attendees.length >= 1) {
        let attendeesEmail = this.attendees.map((at) => at.email);
        this.attendees = this.attendees.concat(
          bookmark.attendees.filter((a) => !attendeesEmail.includes(a.email)),
        );
        this.isActive = '';

        let validEmailList = bookmark.attendees.filter((el) =>
          this.validEmail(el.email),
        );
        let validPhoneList = bookmark.attendees.filter((el) =>
          Util.validationNumber(el.email),
        );

        validEmailList = validEmailList.filter(
          (el) => el.email.indexOf('@krx.co.kr') === -1,
        );
        let count = validEmailList.length + validPhoneList.length;
        if (count > 0) {
          this.exMeeting = true;
          this.exUserDialbled = true;
        }
      }
      this.recentlyBookmarkDialog.dialog = false;
    },
    closeBookmarkDialog(bookmark) {
      // 주소록
      console.log(bookmark);
      if (bookmark && bookmark.attendees && bookmark.attendees.length >= 1) {
        let attendeesEmail = this.attendees.map((at) => at.email);
        this.attendees = this.attendees.concat(
          bookmark.attendees.filter((a) => !attendeesEmail.includes(a.email)),
        );
        this.isActive = '';

        let validEmailList = bookmark.attendees.filter((el) =>
          this.validEmail(el.email),
        );
        let validPhoneList = bookmark.attendees.filter((el) =>
          Util.validationNumber(el.email),
        );
        validEmailList = validEmailList.filter(
          (el) => el.email.indexOf('@krx.co.kr') === -1,
        );
        let count = validEmailList.length + validPhoneList.length;
        if (count > 0) {
          this.exMeeting = true;
          this.exUserDialbled = true;
        }
      }
      this.bookmarkDialog.dialog = false;
    },
    createSelectedList(selectedList) {
      /* @emit function */
      if (selectedList && selectedList.length >= 1) {
        let attendeesEmail = this.attendees.map((at) => at.email);
        this.attendees = this.attendees.concat(
          selectedList.filter((a) => !attendeesEmail.includes(a.email)),
        );
        this.isActive = '';
      }
    },
    closeInvitation() {
      this.initInvitaion();
      this.closeDialog();
    },
    openHelpDialog() {
      this.isHelpActive = '';
    },
    closeHelpDialog() {
      this.isHelpActive = 'none';
    },
    validEmail(email) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
};
</script>
<style scoped>
#meetingInvitation .bt_wrap {
  min-width: 780px;
  width: 780px;
  height: 525px;
}
.popup_top {
  padding-left: 0;
  background-color: #efeefd;
}
.delete-all-btn {
  width: 80px;
  height: 25px;
  float: right;
  font-size: 10pt;
  background: brown;
  color: white;
  border-radius: 5px;
  margin-top: 10px;
}

.member-area-tb {
  padding-top: 10px;
}

.member-area-tb thead {
  background: gray;
  color: white;
}

.member-area-tb th {
  padding-left: 5px;
  text-align: left;
  border: 1px solid black;
}

.selected-layout-wrap {
  float: left;
  width: 50%;
}
.list_info {
  min-height: 240px;
}
.member-top-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.button_area button {
  background: white;
  border: 1px solid #777777;
  color: #333333;
  border: 1px solid #777777;
  height: 40px;
}
.fix-seat-list-wrap {
  float: left;
  width: 50%;
}

.input_area {
  width: 335px !important;
  padding-top: 0px !important;
  padding-bottom: 0px;
}

.help-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.98;
  z-index: 999;
  overflow-y: auto;
  overflow-x: auto;
  text-align: center;
}
.help-img {
  width: 100%;
  max-width: 670px;
  display: inline-block;
  position: relative;
  top: 7%;
}

.close-img {
  position: fixed;
  top: 10%;
  right: 10%;
  cursor: pointer;
  z-index: 1001;
}

.btnArea {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.invite-btn {
  background-color: #604af3;
  color: white;
  width: 130px;
  height: 48px;
  border-radius: 8px;
  margin: 0 5px;
  font-size: 15px;
}
.close-btn {
  width: 82px;
  height: 48px;
  border-radius: 8px;
  background: #f2f2f2;
  color: #1f2e3d;
  margin: 0 5px;
  font-size: 15px;
}

.delete_all {
  background: none;
  height: 30px;
  width: 80px;
  padding: 0;
  margin-bottom: 10px;
}

.user_list li {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

input::placeholder {
  color: #b9b9b9;
  padding-left: 5px;
  font-size: 15px !important;
  font-weight: 100 !important;
  font-family: 'Noto Sans KR', sans-serif !important;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/MeetingInvitaionDialog.vue